module.exports = __webpack_public_path__ + "__assets__/img/avatar.f744cf36.jpg";